﻿import { CopytoClipBoard } from "@shared/Utils";

const isBusiness = () => {
  return window.location.pathname.toLowerCase().startsWith("/bedrift");
};

type shareType = {
  url: string;
  title: string;
};

type urlFnType = (item: HTMLElement, d: shareType) => void;

type urlBuilderMapType = {
  [key: string]: urlFnType;
};

const setHrefAttributes = (item: HTMLElement, url: string): void => {
  item.setAttribute("href", url);
  item.setAttribute("rel", "noopener noreferrer");
  item.setAttribute("target", "_blank");
};

const showCopyMessage = (target: HTMLElement): void => {
  const text = target.querySelector<HTMLElement>(".sharebar__copied-info");
  // animation
  text.classList.remove("fade-in-out");
  void text.offsetWidth;
  text.classList.add("fade-in-out");
};

const supportsNativeShare = (): boolean => {
  return navigator && navigator.share ? true : false;
};

const utmUrl = (url: string, source: string): string => {
  const querySign = url.indexOf("?") !== -1 ? "&" : "?";

  return `${url}${querySign}utm_source=${source}&utm_content=Deleknapp`;
};

const urlBuilderMap: urlBuilderMapType = {
  facebook: (item: HTMLElement, d: shareType): void => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${utmUrl(d.url, "facebook")}`;
    setHrefAttributes(item, url);
  },
  linkedin: (item: HTMLElement, d: shareType): void => {
    const url: string = `https://www.linkedin.com/shareArticle?mini=true&url=${utmUrl(d.url, "linkedin")}`;
    setHrefAttributes(item, url);
  },
  link: (item: HTMLElement, d: shareType): void => {
    item.setAttribute("href", "#");

    item.addEventListener("click", (e) => {
      e.preventDefault();
      CopytoClipBoard(d.url);
      showCopyMessage(item);
    });
  },
  mail: (item: HTMLElement, d: shareType): void => {
    setHrefAttributes(item, `mailto:?subject=${d.title}&body=${utmUrl(d.url, "email")}`);
  },
  shareNative: (item: HTMLElement, d: shareType): void => {
    item.setAttribute("href", "#");
    item.addEventListener("click", (e) => {
      e.preventDefault();
      navigator
        .share({
          title: d.title,
          url: utmUrl(d.url, "navigator-share"),
        })
        .catch(console.error);
    });
  },
};

const mapData = (item: HTMLElement, data: shareType): void => {
  const name = item.dataset.name;
  if (Object.prototype.hasOwnProperty.call(urlBuilderMap, name) && name !== undefined) {
    urlBuilderMap[name](item, data);
  }
};

const shareBarElement = (mainContainer: HTMLElement): void => {
  const setting: shareType = {
    url: mainContainer.dataset.url,
    title: mainContainer.dataset.title,
  };

  if (isBusiness()) {
    const linkedinEl = mainContainer.querySelector("[data-name='linkedin']");
    if (linkedinEl) {
      linkedinEl.classList.remove("hidden");
    }
  } else {
    const facebookEl = mainContainer.querySelector("[data-name='facebook']");
    if (facebookEl) {
      facebookEl.classList.remove("hidden");
    }
  }

  if (supportsNativeShare()) {
    const shareNativeEl = mainContainer.querySelector("[data-name='shareNative']");
    if (shareNativeEl) {
      shareNativeEl.classList.remove("hidden");
    }
  } else {
    const infoTextEl = mainContainer.querySelector(".sharebar__info-text");
    if (infoTextEl) {
      infoTextEl.classList.remove("hidden");
    }
  }

  mainContainer.querySelectorAll<HTMLAnchorElement>("[data-name]").forEach((item: HTMLElement): void => {
    mapData(item, setting);
  });
};

document.querySelectorAll<HTMLElement>(".js-share-bar").forEach((containerItem: HTMLElement): void => {
  shareBarElement(containerItem);
});
